export default function MySQL_Home() {
  return (
    <div>
      <h2>MySQL_Home</h2> uysd uysdgsd uysd jhg n jhyijsd yagsd{" "}
    </div>
  );
}
